import { render, staticRenderFns } from "./serviceInformation.vue?vue&type=template&id=5b2cf70a&"
import script from "./serviceInformation.vue?vue&type=script&lang=js&"
export * from "./serviceInformation.vue?vue&type=script&lang=js&"
import style0 from "./serviceInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports